// extracted by mini-css-extract-plugin
module.exports = {"participants":"_298f74d","participant":"_ee287b1","srOnly":"_501a115","americanFirstParticipant":"_ac593c5"};